import { render, staticRenderFns } from "./CrossPeriodMessage.vue?vue&type=template&id=ee07e4fc&scoped=true&"
import script from "./CrossPeriodMessage.vue?vue&type=script&lang=js&"
export * from "./CrossPeriodMessage.vue?vue&type=script&lang=js&"
import style0 from "./CrossPeriodMessage.vue?vue&type=style&index=0&id=ee07e4fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee07e4fc",
  null
  
)

export default component.exports